import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import PageLayout from "@/components/feature/PageLayout";
import { siteStats } from "@/mocks/movies";
import { usePageMeta } from "@/hooks/usePageMeta";

const sections = [
  {
    id: "position",
    eyebrow: "Position",
    title: "站点定位",
    paragraphs: [
      "诱人的女员工hd影视专区是一个以图文资讯为核心的影视内容站，我们把电影与电视剧的基础资料、剧情脉络与主创信息整理成统一结构，帮助观众在观看之前先建立清晰的判断。",
      "我们不追求信息堆叠，而是尽量用一页内容讲清楚一部作品：它讲了什么故事、由谁完成、适合什么心情的时候看。",
    ],
  },
  {
    id: "scope",
    eyebrow: "Scope",
    title: "内容范围",
    paragraphs: [
      "站内内容分为四类：影视作品资料（类型、地区、年份、时长）、剧情简介与解析、演员与角色对照、以及由编辑整理的专题片单。",
      "所有作品名称、人物与剧情均为示范性虚构内容，用于展示页面结构与阅读体验，不对应任何真实影视作品或真实人物。本站不提供影片播放、资源下载、会员订阅等相关服务。",
    ],
  },
  {
    id: "notice",
    eyebrow: "Notice",
    title: "使用须知",
    paragraphs: [
      "站内评分与播放量为演示数据，仅用于列表排序与界面展示，不代表任何真实统计结果。",
      "收藏功能仅使用浏览器本地存储，不会上传到服务器；清除浏览器数据后收藏记录会一并消失，也不会跨设备同步。",
      "如发现页面内容存在明显错误，欢迎通过下方邮箱反馈，我们会在下一个版本中校正。",
    ],
  },
];

export default function About() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const target = document.getElementById(location.hash.replace("#", ""));
      if (target) {
        window.setTimeout(() => target.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.hash]);

  usePageMeta(
    "关于我们 - 诱人的女员工hd影视专区",
    "了解诱人的女员工hd影视专区的站点定位、内容范围、联系方式与使用须知，站内影视资料均为示范性虚构内容。",
  );

  return (
    <PageLayout>
      <section className="border-b border-background-200 bg-primary-950">
        <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-xs text-primary-300">
            <Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">
              首页
            </Link>
            <i className="ri-arrow-right-s-line w-3.5 h-3.5 flex items-center justify-center text-primary-500" />
            <span className="text-primary-100">关于我们</span>
          </nav>
          <h1 className="mt-4 max-w-2xl text-2xl font-bold tracking-tight text-background-50 md:text-4xl">
            关于「诱人的女员工hd影视专区」
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-primary-200 md:text-base">
            我们相信选择一部作品和读完一段简介之间，应该只差一次点击。这里是我们整理影视内容的方式，也是我们希望被使用的方式。
          </p>
        </div>
      </section>

      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-2 gap-6 px-4 py-8 md:grid-cols-4 md:px-6 md:py-10">
          {siteStats.map((stat) => (
            <div key={stat.label} className="min-w-0">
              <p className="font-label text-2xl font-semibold tracking-tight text-foreground-950 md:text-3xl">{stat.value}</p>
              <p className="mt-1 text-xs text-foreground-500 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1fr_320px]">
        <div className="min-w-0 space-y-12">
          {sections.map((section) => (
            <section key={section.id} id={section.id} className="scroll-mt-24">
              <span className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-600">{section.eyebrow}</span>
              <h2 className="mt-2 text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">{section.title}</h2>
              <div className="mt-4 space-y-4">
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph.slice(0, 14)} className="text-sm leading-8 text-foreground-700">
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}

          <section id="contact" className="scroll-mt-24">
            <span className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-600">Contact</span>
            <h2 className="mt-2 text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">联系方式</h2>
            <p className="mt-4 text-sm leading-8 text-foreground-700">
              内容纠错、合作咨询或转载授权，都欢迎通过邮件与我们联系。我们通常在两个工作日内回复。
            </p>
            <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
              <a
                href="mailto:hello@yinglian-hd.example"
                className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-accent-300 cursor-pointer"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-950 text-background-50">
                  <i className="ri-mail-line text-base" />
                </span>
                <span className="min-w-0">
                  <span className="block text-xs text-foreground-500">内容反馈邮箱</span>
                  <span className="mt-0.5 block truncate text-sm font-medium text-foreground-950">
                    hello@yinglian-hd.example
                  </span>
                </span>
              </a>
              <Link
                to="/category"
                className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-accent-300 cursor-pointer"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-200 text-secondary-900">
                  <i className="ri-message-2-line text-base" />
                </span>
                <span className="min-w-0">
                  <span className="block text-xs text-foreground-500">站内留言入口</span>
                  <span className="mt-0.5 block truncate text-sm font-medium text-foreground-950">前往影视分类页挑片</span>
                </span>
              </Link>
            </div>
          </section>

          <section id="privacy" className="scroll-mt-24">
            <span className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-600">Privacy</span>
            <h2 className="mt-2 text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">隐私政策</h2>
            <p className="mt-4 text-sm leading-8 text-foreground-700">
              本站不收集账号信息，不要求登录，也不向第三方出售任何数据。页面中唯一写入本地存储的内容是收藏记录，
              它仅存在于你的浏览器中，用于下次访问时恢复收藏状态。你可以随时在详情页取消收藏，或清除浏览器数据来移除全部记录。
            </p>
          </section>
        </div>

        <aside className="h-fit rounded-lg border border-background-200 bg-background-100 p-5 lg:sticky lg:top-24">
          <h2 className="text-sm font-medium text-foreground-950">本页目录</h2>
          <div className="mt-3 flex flex-col gap-1">
            {[...sections, { id: "contact", title: "联系方式" }, { id: "privacy", title: "隐私政策" }].map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-600 transition-colors hover:bg-background-50 hover:text-accent-600 cursor-pointer"
              >
                <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-foreground-400" />
                {item.title}
              </a>
            ))}
          </div>
          <div className="mt-5 rounded-md bg-background-50 p-4">
            <p className="text-xs leading-6 text-foreground-500">
              本站为影视资讯展示站点，不提供播放与下载功能，也不销售任何会员或资源。
            </p>
            <Link
              to="/"
              className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-600 hover:text-accent-700 cursor-pointer whitespace-nowrap"
            >
              返回首页
              <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center" />
            </Link>
          </div>
        </aside>
      </div>
    </PageLayout>
  );
}